export default "__VITE_ASSET__PMO1pmjR__"